import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { TimeOfDayTileComponent } from './time-of-day-tile.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule.withConfig({ useColumnBasisZero: false }), SharedModule],
  declarations: [TimeOfDayTileComponent],
  exports: [TimeOfDayTileComponent]
})
export class TimeOfDayTileModule {}
